export default __webpack_public_path__ + "static/media/logo-cooasgo-horizontal.111f65ee.png";